import type { QueryClient } from '@tanstack/react-query';
import { resyncNotificationModel } from '@/lib/realtime/notification-handler';
import type { RealtimeContext, RealtimeEvent } from '@/types/realtime';

const PROJECT_CACHE_RESYNC_KEYS: readonly unknown[][] = [
  ['projects', 'list'],
  ['projects', 'detail'],
  ['folders', 'tree'],
  ['context-resource-summary'],
  ['resource-library', 'v1'],
  ['project-elements'],
  ['project-element-tags'],
  ['storyboards'],
  ['storyboardBoard'],
  ['storyboard-reviews'],
  ['screenplays', 'list'],
  ['screenplay-workflow-snapshot'],
];

export function handleRealtimeResyncEvent(
  queryClient: QueryClient,
  event: RealtimeEvent,
  _context: RealtimeContext
): void {
  if (event.topic !== 'resync') return;

  void resyncNotificationModel();
  for (const queryKey of PROJECT_CACHE_RESYNC_KEYS) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
